module.exports = __webpack_public_path__ + "static/media/fal_fal_har.c975f977.png";